import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useNavigate } from "react-router-dom";
import { Smartphone } from "lucide-react";
import { useFetch } from "@/lib/hooks";
import { useAuth } from "@/lib/auth";
import { money, fdate } from "@/lib/api";
import { PageHeader, StatusBadge, Loading, Empty, DemoBadge } from "@/components/common";
import { FineTicket } from "@/pages/intranet/Field";

export default function Fines() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const list = useFetch("/fines", { poll: 10000 });
  const [q, setQ] = useState("");
  const [sel, setSel] = useState(null);
  const rows = (list.data || []).filter((f) => !q || `${f.folio} ${f.plate} ${f.reason} ${f.offender_name}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <div>
      <PageHeader eyebrow="Multas y requerimientos" title="Boletas digitales" subtitle="Todas las infracciones emitidas con evidencia geolocalizada, firma digital y código QR."
        actions={user.role === "agente" && <Button onClick={() => navigate("/app/campo")} data-testid="fines-new-button"><Smartphone className="h-4 w-4 mr-1" />Emitir multa</Button>} />
      <Card><CardContent className="p-4">
        <Input placeholder="Buscar folio, placa, motivo" value={q} onChange={(e) => setQ(e.target.value)} className="max-w-xs mb-4" data-testid="fines-search-input" />
        {list.loading ? <Loading /> : !rows.length ? <Empty title="Sin boletas" /> : (
          <div className="overflow-x-auto"><Table>
            <TableHeader><TableRow><TableHead>Folio</TableHead><TableHead>Motivo</TableHead><TableHead className="hidden md:table-cell">Placa</TableHead><TableHead className="hidden md:table-cell">Municipio</TableHead><TableHead className="hidden lg:table-cell">Fecha</TableHead><TableHead className="text-right">Monto</TableHead><TableHead>Estatus</TableHead></TableRow></TableHeader>
            <TableBody>{rows.map((f) => (
              <TableRow key={f.folio} className="cursor-pointer hover:bg-secondary/60" onClick={() => setSel(f)} data-testid={`fine-row-${f.folio}`}>
                <TableCell className="font-mono text-xs">{f.folio}</TableCell><TableCell className="text-sm">{f.reason} {f.is_demo && <DemoBadge />}</TableCell>
                <TableCell className="hidden md:table-cell font-mono text-xs">{f.plate || "—"}</TableCell><TableCell className="hidden md:table-cell text-sm">{f.municipio}</TableCell>
                <TableCell className="hidden lg:table-cell text-xs">{fdate(f.created_at)}</TableCell><TableCell className="text-right font-mono">{money(f.amount)}</TableCell>
                <TableCell><StatusBadge status={f.status} /></TableCell>
              </TableRow>
            ))}</TableBody>
          </Table></div>
        )}
      </CardContent></Card>
      <Dialog open={!!sel} onOpenChange={(o) => !o && setSel(null)}>
        <DialogContent className="bg-white sm:max-w-md max-h-[92vh] overflow-y-auto">
          <DialogHeader><DialogTitle>Boleta digital</DialogTitle></DialogHeader>
          {sel && <FineTicket fine={sel} />}
        </DialogContent>
      </Dialog>
    </div>
  );
}

